export const setLoginPageComponent = (payload, email) => ({
  type: "SET_LOGIN_PAGE_COMPONENT",
  payload,
  email,
});
